import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRegisterSW } from "virtual:pwa-register/react";
import { toast } from "@/hooks/useToast";
import { ToastAction } from "@/components/ui/toast";

// Ogni quanto chiedere al browser se c'è un nuovo service worker (= nuovo deploy).
// Con HashRouter non ci sono navigazioni vere, quindi senza questo controllo chi
// tiene la scheda aperta resterebbe sulla versione vecchia.
const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;

/**
 * Mostra un toast persistente quando è disponibile una nuova versione dell'app
 * e ricarica solo su conferma dell'utente, così non si perde lavoro non salvato.
 */
const UpdatePrompt = () => {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;

      const checkForUpdate = () => {
        if (registration.installing || !navigator.onLine) return;
        registration.update().catch(() => {
          // Rete assente o sw.js non raggiungibile: si riprova al prossimo giro
        });
      };

      setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") checkForUpdate();
      });
    },
  });

  useEffect(() => {
    if (!needRefresh) return;

    toast({
      title: t("appUpdate.title"),
      description: t("appUpdate.description"),
      duration: Infinity,
      action: (
        <ToastAction altText={t("appUpdate.reload")} onClick={() => updateServiceWorker(true)}>
          {t("appUpdate.reload")}
        </ToastAction>
      ),
    });
  }, [needRefresh, t, updateServiceWorker]);

  return null;
};

export default UpdatePrompt;
